import { render } from "./NCTable.vue?vue&type=template&id=65bf2f65"
import script from "./NCTable.vue?vue&type=script&lang=js"
export * from "./NCTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__